export default {"src":"/_next/static/media/icondum.6b52ff37.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};